import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79a48f03"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"60px"} }, null, -1))

import { useAppStore } from '@/store'
import { computed, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'footer-bar',
  props: {
  loading: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "0dae7146": (sidebarWidth.value)
}))

const app = useAppStore()
const { sidebarStatus } = toRefs(app)
const props = __props
const { loading } = toRefs(props)
const sidebarWidth = computed(() => {
  return sidebarStatus.value === 'open' ? '220px' : '48px'
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "footer-bar" }, _ctx.$attrs), [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_component_a_space, {
          class: "d-flex justify-content-center align-items-center",
          style: {"height":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 返回 ")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save'))),
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ])
    ], 16),
    _hoisted_1
  ], 64))
}
}

})